<div class="container">
  <div class="text-center">
    <h1>Referral Successfully Sent</h1>
    <p>
      Thank you for your Referral. We will contact your friend shortly
    </p>
    <button class="btn btn-primary" [routerLink]="['/referAFriend']">Close</button>
  </div>
</div>
